// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"t1-z","dimensionLabel":"u1-z","styleChooserControlWrapper":"v1-z","styleChooserControl":"w1-z","disabled":"x1-z","giftCard":"y1-z","styleChooserText":"z1-z"};